import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EmailSettingInterface } from '@pages/administration/interfaces/email-setting-interface';
import { Select, Store } from '@ngxs/store';
import { AppStateSelectors } from '@appState/app-state.selector';
import { Observable } from 'rxjs';
import { AdministrationStateSelectors } from '@pages/administration/state/administration.selectors';
import { TGetMailSwitchesDTO, TPutMailSwitchesDTO } from '@api';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SetEMailSettings } from '@pages/administration/state/administration.actions';
import { MatDialogRef } from '@angular/material/dialog';

@UntilDestroy()
@Component({
  selector: 'app-email-settings-dialog',
  templateUrl: './email-settings-dialog.component.html',
  styleUrl: './email-settings-dialog.component.scss',
})
export class EmailSettingsDialogComponent implements OnInit {
  @Select(AppStateSelectors.isUserVNB())
  public isUserVNB$: Observable<boolean>;

  @Select(AppStateSelectors.isUserOGE())
  public isUserOGE$: Observable<boolean>;

  @Select(AppStateSelectors.isUserH2Customer())
  public isUserH2Customer$: Observable<boolean>;

  @Select(AppStateSelectors.isUserCo2Customer())
  public isUserC02Customer$: Observable<boolean>;

  @Select(AppStateSelectors.isUserAdmin())
  public isUserAdmin$: Observable<boolean>;

  @Select(AdministrationStateSelectors.getEMailSettings)
  public readonly eMailSettings$: Observable<TGetMailSwitchesDTO>;

  public form: FormGroup<EmailSettingInterface>;

  constructor(
    public dialogRef: MatDialogRef<EmailSettingsDialogComponent>,
    private readonly formBuilder: FormBuilder,
    private readonly store: Store
  ) {}

  public ngOnInit() {
    this.form = this.formBuilder.group({
      location_mail: [null],
      new_user_mail: [null],
      location_changed_mail: [null],
      co2_facility_mail: [null],
      new_vnb_mail: [null],
    });

    this.eMailSettings$
      .pipe(untilDestroyed(this))
      .subscribe(eMailSettings => this.fillDataInForm(eMailSettings));
  }

  private fillDataInForm(eMailSettings: TGetMailSwitchesDTO) {
    if (eMailSettings) {
      this.form.controls.location_mail.setValue(
        eMailSettings.sendNewFacilityEmail
      );
      this.form.controls.new_user_mail.setValue(eMailSettings.sendNewUserEmail);
      this.form.controls.location_changed_mail.setValue(
        eMailSettings.sendDanglingFacilityEmail
      );
      this.form.controls.new_vnb_mail.setValue(
        eMailSettings.sendNewVNBFirstUserEmail
      );
      this.form.controls.co2_facility_mail.setValue(
        eMailSettings.sendNewCo2FacilityEmail
      );
    }
  }

  public save() {
    const dto: TPutMailSwitchesDTO = {
      sendNewFacilityEmail: this.form.controls.location_mail.getRawValue(),
      sendNewUserEmail: this.form.controls.new_user_mail.getRawValue(),
      sendDanglingFacilityEmail:
        this.form.controls.location_changed_mail.getRawValue(),
      sendNewCo2FacilityEmail:
        this.form.controls.co2_facility_mail.getRawValue(),
      sendNewVNBFirstUserEmail: this.form.controls.new_vnb_mail.getRawValue(),
    };
    this.store.dispatch(new SetEMailSettings(dto));
    this.dialogRef.close();
  }

  public getNewUserMailLabel(isUserOge: boolean): string {
    if (isUserOge) {
      return 'administration.email.new_user_mail_oge';
    }
    return 'administration.email.new_user_mail';
  }

  public getLocationMailCo2Label(isUserOge: boolean): string {
    if (isUserOge) {
      return 'administration.email.location_mail_co2_oge';
    }
    return 'administration.email.location_mail_co2';
  }
}
